const keys = {
    GET_PROGRAMS_LIST: (page_id: number) => `/programs/${page_id}`,
    GET_PROGRAM_SHOW: (id: number, day: number) => [`/programs/${id}/show`, day],
    POST_PROGRAM_TOGGLE_TASK: (id: number) => `/programs/${id}/toggle-task`,
    GET_PROGRAM_REPORT: (id: number) => `/programs/${id}/report`,
    POST_REPORT_FEEDBACK: (id: number) => `/programs/report/${id}`
};

export default keys;

